/* MANAGING THE VARIABLES
  * Managing the variables can be done in the CMS in this text field (js_variables)
  * This text field can be added in (Model.WebSite.Fields) or (Model.Fields)
  * To overwrite a variable for a specific page, use (Model.Fields), otherwise use (Model.WebSite.Fields)
  * The syntax will be: RP6_VARS.[variableName] = [the value you want]
*/

/* TARGETING A SECTION
  * You can overwrite a variable for a specific section
  * These specific sections are: PIDK, NEWS, TESTIMONIALS, JUMBOTRON
  * The syntax will be: RP6_VARS.[SECTION]_[variableName] = [the value you want]
  * E.g:
  *   RP6_VARS.PIDK_centerMode = true;
  *   RP6_VARS.TESTIMONIALS_slidesToShow = 3;
*/

RP6_VARS.stopAnimationStats = RP6_VARS.stopAnimationStats === undefined ?
  false : RP6_VARS.stopAnimationStats;

RP6_VARS.thumbs = RP6_VARS.thumbs === undefined ?
  false : RP6_VARS.thumbs;

RP6_VARS.timeSpeed = RP6_VARS.timeSpeed === undefined ?
  1000 : RP6_VARS.timeSpeed;

RP6_VARS.slidesToShowXL = RP6_VARS.slidesToShowXL === undefined ?
  1 : RP6_VARS.slidesToShowXL;

RP6_VARS.slidesToShowLG = RP6_VARS.slidesToShowLG === undefined ?
  1 : RP6_VARS.slidesToShowLG;

RP6_VARS.slidesToShowMD = RP6_VARS.slidesToShowMD === undefined ?
  1 : RP6_VARS.slidesToShowMD;

RP6_VARS.offerDefaultView = RP6_VARS.offerDefaultView === undefined ?
  'gallery' : RP6_VARS.offerDefaultView; //list, gallery, map

RP6_VARS.search = RP6_VARS.search === undefined ?
  'search_sidebar' : RP6_VARS.search;

RP6_VARS.scroll = RP6_VARS.scroll === undefined ?
  'pagination' : RP6_VARS.scroll;

//Slick
RP6_VARS.adaptiveHeight = RP6_VARS.adaptiveHeight === undefined ?
  false : RP6_VARS.adaptiveHeight;

RP6_VARS.autoplay = RP6_VARS.autoplay === undefined ?
  false : RP6_VARS.autoplay;

RP6_VARS.autoplaySpeed = RP6_VARS.autoplaySpeed === undefined ?
  3000 : RP6_VARS.autoplaySpeed;

RP6_VARS.arrows = RP6_VARS.arrows === undefined ?
  "" : RP6_VARS.arrows;

RP6_VARS.asNavFor = RP6_VARS.asNavFor === undefined ?
  null : RP6_VARS.asNavFor;

RP6_VARS.prevArrow = RP6_VARS.prevArrow === undefined ?
  '<a class="carousel-control-prev" role="button"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>' : RP6_VARS.prevArrow;

RP6_VARS.nextArrow = RP6_VARS.nextArrow === undefined ?
  '<a class="carousel-control-next" role="button"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>' : RP6_VARS.nextArrow;

RP6_VARS.centerMode = RP6_VARS.centerMode === undefined ?
  false : RP6_VARS.centerMode;

RP6_VARS.centerPadding = RP6_VARS.centerPadding === undefined ?
  '50px' : RP6_VARS.centerPadding;

RP6_VARS.cssEase = RP6_VARS.cssEase === undefined ?
  'ease-in-out' : RP6_VARS.cssEase;

RP6_VARS.customPaging = RP6_VARS.customPaging === undefined ?
  function (slider, i) {
    if (RP6_VARS.thumbs) {
        var thumb = $(slider.$slides[i]).find('.carousel-item__image img').attr('src');
        return '<img src="' + thumb + '" class="image--thumb">';
      }
  } : RP6.customPaging;

RP6_VARS.dots = RP6_VARS.dots === undefined ?
  false : RP6_VARS.dots;

RP6_VARS.dotsClass = RP6_VARS.dotsClass === undefined ?
  'carousel-indicators' : RP6_VARS.dotsClass;

RP6_VARS.draggable = RP6_VARS.draggable === undefined ?
  true : RP6_VARS.draggable;

RP6_VARS.fade = RP6_VARS.fade === undefined ?
  false : RP6_VARS.fade;

RP6_VARS.focusOnSelect = RP6_VARS.focusOnSelect === undefined ?
  true : RP6_VARS.focusOnSelect;

RP6_VARS.easing = RP6_VARS.easing === undefined ?
  'ease-in-out' : RP6_VARS.easing;

RP6_VARS.edgeFriction = RP6_VARS.edgeFriction === undefined ?
  0.15 : RP6_VARS.edgeFriction;

RP6_VARS.infinite = RP6_VARS.infinite === undefined ?
  true : RP6_VARS.infinite;

RP6_VARS.initialSlide = RP6_VARS.initialSlide === undefined ?
  0 : RP6_VARS.initialSlide;

RP6_VARS.lazyLoad = RP6_VARS.lazyLoad === undefined ?
  'ondemand' : RP6_VARS.lazyLoad;

RP6_VARS.mobileFirst = RP6_VARS.mobileFirst === undefined ?
  false : RP6_VARS.mobileFirst;

RP6_VARS.pauseOnFocus = RP6_VARS.pauseOnFocus === undefined ?
  true : RP6_VARS.pauseOnFocus;

RP6_VARS.pauseOnHover = RP6_VARS.pauseOnHover === undefined ?
  true : RP6_VARS.pauseOnHover;

RP6_VARS.pauseOnDotsHover = RP6_VARS.pauseOnDotsHover === undefined ?
  false : RP6_VARS.pauseOnDotsHover;

RP6_VARS.respondTo = RP6_VARS.respondTo === undefined ?
  'window' : RP6_VARS.respondTo;

RP6_VARS.responsive = RP6_VARS.responsive === undefined ?
  [
    {
        breakpoint: 1199,
        settings: {
            slidesToShow: RP6_VARS.slidesToShowLG
        }
    },
    {
        breakpoint: 991,
        settings: {
            slidesToShow: RP6_VARS.slidesToShowMD
        }
    },
    {
        breakpoint: 767,
        settings: {
            slidesToShow: 1
        }
    }
  ] : RP6_VARS.responsive;

RP6_VARS.rows = RP6_VARS.rows === undefined ?
  1 : RP6_VARS.rows;

RP6_VARS.slidesPerRow = RP6_VARS.slidesPerRow === undefined ?
  1 : RP6_VARS.slidesPerRow;

RP6_VARS.slidesToShow = RP6_VARS.slidesToShow === undefined ?
  1 : RP6_VARS.slidesToShow;

RP6_VARS.slidesToScroll = RP6_VARS.slidesToScroll === undefined ?
  1 : RP6_VARS.slidesToScroll;

RP6_VARS.speed = RP6_VARS.speed === undefined ?
  300 : RP6_VARS.speed;

RP6_VARS.swipe = RP6_VARS.swipe === undefined ?
  true : RP6_VARS.swipe;

RP6_VARS.swipeToSlide = RP6_VARS.swipeToSlide === undefined ?
  false : RP6_VARS.swipeToSlide;

RP6_VARS.touchMove = RP6_VARS.touchMove === undefined ?
  true : RP6_VARS.touchMove;

RP6_VARS.touchThreshold = RP6_VARS.touchThreshold === undefined ?
  5 : RP6_VARS.touchThreshold;

RP6_VARS.useCSS = RP6_VARS.useCSS === undefined ?
  true : RP6_VARS.useCSS;

RP6_VARS.useTransform = RP6_VARS.useTransform === undefined ?
  true : RP6_VARS.useTransform;

RP6_VARS.variableWidth = RP6_VARS.variableWidth === undefined ?
  false : RP6_VARS.variableWidth;

RP6_VARS.vertical = RP6_VARS.vertical === undefined ?
  false : RP6_VARS.vertical;

RP6_VARS.verticalSwiping = RP6_VARS.verticalSwiping === undefined ?
  false : RP6_VARS.verticalSwiping;

RP6_VARS.rtl = RP6_VARS.rtl === undefined ?
  false : RP6_VARS.rtl;

RP6_VARS.waitForAnimate = RP6_VARS.waitForAnimate === undefined ?
  true : RP6_VARS.waitForAnimate;

RP6_VARS.zIndex = RP6_VARS.zIndex === undefined ?
  1000 : RP6_VARS.zIndex;

/* COMMON TEMPLATE SETTINGS
  * You can always overwrite them in the CMS in (js_variables)
  * Add only the common settings in this file
*/
// -- PIDK
RP6_VARS.PIDK_autoplay = RP6_VARS.PIDK_autoplay === undefined ?
    true : RP6_VARS.PIDK_autoplay;
RP6_VARS.PIDK_centerMode = RP6_VARS.PIDK_centerMode === undefined ? 
    true : RP6_VARS.PIDK_centerMode;
RP6_VARS.PIDK_variableWidth = RP6_VARS.PIDK_variableWidth === undefined ?
    true : RP6_VARS.PIDK_variableWidth;
RP6_VARS.PIDK_dots = RP6_VARS.PIDK_dots === undefined ?
    true : RP6_VARS.PIDK_dots;
RP6_VARS.PIDK_swipeToSlide = RP6_VARS.PIDK_swipeToSlide === undefined ? 
    true : RP6_VARS.PIDK_swipeToSlide;

// -- JUMBOTRIN
RP6_VARS.JUMBOTRON_dots = RP6_VARS.JUMBOTRON_dots === undefined ?
    true : RP6_VARS.JUMBOTRON_dots;
RP6_VARS.JUMBOTRON_fade = RP6_VARS.JUMBOTRON_fade === undefined ?
    true : RP6_VARS.JUMBOTRON_fade;

// -- TESTIMONIALS
RP6_VARS.TESTIMONIALS_arrows = RP6_VARS.TESTIMONIALS_arrows === undefined ?
    true : RP6_VARS.TESTIMONIALS_arrows;
RP6_VARS.TESTIMONIALS_centerMode = RP6_VARS.TESTIMONIALS_centerMode === undefined ?
    false : RP6_VARS.TESTIMONIALS_centerMode;
RP6_VARS.TESTIMONIALS_slidesToShow = RP6_VARS.TESTIMONIALS_slidesToShow === undefined ? 
    1 : RP6_VARS.TESTIMONIALS_slidesToShow;
RP6_VARS.TESTIMONIALS_variableWidth = RP6_VARS.TESTIMONIALS_variableWidth === undefined ?
    false : RP6_VARS.TESTIMONIALS_variableWidth;

// -- DETAIL
RP6_VARS.DETAIL_centerPadding = RP6_VARS.DETAIL_centerPadding === undefined ?
    "10%" : RP6_VARS.DETAIL_centerPadding;
RP6_VARS.DETAIL_dots = RP6_VARS.DETAIL_dots === undefined ?
    true : RP6_VARS.DETAIL_dots;
RP6_VARS.DETAIL_arrows = RP6_VARS.DETAIL_arrows === undefined ?
    true : RP6_VARS.DETAIL_arrows;
RP6_VARS.DETAIL_centerMode = RP6_VARS.DETAIL_centerMode === undefined?
    true : RP6_VARS.DETAIL_centerMode;
RP6_VARS.DETAIL_responsive = RP6_VARS.DETAIL_responsive === undefined ?
    [{ breakpoint: 992, settings: { centerMode: false, dots: false } }] : RP6_VARS.DETAIL_responsive;
RP6_VARS.DETAIL_arrows = RP6_VARS.DETAIL_arrows === undefined ?
    true : RP6_VARS.DETAIL_arrows;
RP6_VARS.DETAIL_variableWidth = RP6_VARS.DETAIL_variableWidth === undefined ?
    true : RP6_VARS.DETAIL_variableWidth;
RP6_VARS.DETAIL_variableHeight = RP6_VARS.DETAIL_variableHeight === undefined ?
    false : RP6_VARS.DETAIL_variableHeight;

/* JSONified ProjectModels */
RP6_VARS.jsonTransactions = [];
RP6_VARS.globalSettings = {};
RP6_VARS.projectsResult = {};
RP6_VARS.hasMarketingType = false;

/* SUBCITIES KOPPELEN */
RP6_VARS.rebindCity = RP6_VARS.rebindCity === undefined ? [] : RP6_VARS.rebindCity;